module.exports = __webpack_public_path__ + "static/media/ue.6c9aad23.svg";